import { useTranslation } from 'next-i18next';

import Link from 'next/link';
import Avatar from 'components/Avatar';
import { ButtonV3 } from 'components/ComponentV2';
import { useResponsive } from 'hooks/useResponsive';
import { PAGE_ROUTES } from 'lib/page-routes';
import { TBasicCompany } from 'lib/models/company';

import styles from '../CommunityCard/CommunityCard.module.scss';

type CompanyCardProps = {
  company: TBasicCompany;
};

const CompanyCard: React.FC<CompanyCardProps> = ({ company }) => {
  const screens = useResponsive();
  const [tCommon] = useTranslation('common');
  const { name, icon_url, industry_name, slug } = company;
  const route = PAGE_ROUTES.COMPANY_PUBLIC.replace('[slug]', slug);

  const content = (
    <section className={styles.container}>
      <Avatar icon={icon_url} name={name} className={styles.image} size={'40'} />
      <div className={styles.names}>
        <label title={name} className={styles.name}>
          {name}
        </label>
        <label title={industry_name} className={styles['sub-name']}>
          {industry_name}
        </label>
      </div>
      <a href={route} target="_blank" className={styles.link} rel="noreferrer">
        <ButtonV3 color="secondary" isFullWidth className={styles.button}>
          {tCommon('view')}
        </ButtonV3>
      </a>
    </section>
  );

  return screens.sm ? (
    <Link href={route} passHref>
      <a>{content}</a>
    </Link>
  ) : (
    content
  );
};

CompanyCard.displayName = 'CompanyCard';

export default CompanyCard;
